import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import findIndex from 'lodash-es/findIndex';
import { Subscription } from 'rxjs/internal/Subscription';
import { CheckoutServiceDecorator } from './checkout-service.service.decorator';

@Component({
    selector: 'checkout-nav',
    templateUrl: './checkout-nav.html',
    styleUrl: './checkout-nav.component.scss',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutNavComponent implements OnInit, OnDestroy {
    steps?: Checkout.IStep[];

    private subscriptions = new Subscription();

    private checkout = inject(CheckoutServiceDecorator);

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private app: App
    ) {}

    ngOnInit() {
        this.subscriptions.add(this.checkout.stepsChange.subscribe((steps: Checkout.IStep[] | undefined) => this.onStepsUpdate(steps)));
        this.subscriptions.add(this.app.events.on(Checkout.EVENTS.StepChange).subscribe(() => this.detectChanges()));
        this.onStepsUpdate(this.checkout.steps);
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    protected onStepsUpdate(steps: Checkout.IStep[] | undefined): void {
        const visibleSteps: Checkout.IStep[] = [];

        if (steps?.length) {
            steps.forEach(step => {
                if (step.order && (!step.stepGroup || !visibleSteps.find(visibleStep => visibleStep.stepGroup === step.stepGroup))) {
                    visibleSteps.push(step);
                }
            });
        }

        this.steps = visibleSteps;

        this.detectChanges();
    }

    get currentStepIndex(): number | undefined {
        if (this.currentStep && this.steps?.length) {
            if (this.currentStep.stepGroup) {
                return findIndex(this.steps, step => step.stepGroup === this.currentStep?.stepGroup);
            } else {
                return findIndex(this.steps, step => step === this.currentStep);
            }
        }
        return undefined;
    }

    get currentStep(): Checkout.IStep | undefined {
        if (this.steps?.length) {
            const step = this.steps[0];
            return step.currentStep;
        }
        return undefined;
    }

    getStepWidth(isMiddle: boolean): string {
        const length = this.steps?.length || 1;

        return `${((isMiddle ? 2 : 1) / (length * 2 - 2)) * 100}%`;
    }

    protected detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
